import { heartIconFilled, heartIconOutlined } from "../components/Icons";
import { pushEvent, IEventAttributes } from "../Events";
import { IVideo } from "../WidgetTvTypes";

export function makeLikeProvider({
  likeButton,
  getCurrentVideo,
  onLiked,
}: {
  likeButton: HTMLElement
  getCurrentVideo: () => IVideo
  onLiked: (id: string) => void
}) {
  const liked: {
    items: { [id: string]: boolean };
    particles: (HTMLElement & {
      t: number;
      a: number;
      direction: [number, number];
    })[];
  } = {
    items: {},
    particles: [],
  };

  try {
    liked.items = JSON.parse(localStorage.getItem("sw_liked_2") || "{}");
  } catch (err) {}

  function getCurrentId() {
    const video = getCurrentVideo();
    return video && (video.id || video.videoId || video.title);
  }

  function getCurrentLikeState() {
    const id = getCurrentId();
    if (id) return liked.items[id];
  }

  function toggleLikeState(ev: MouseEvent) {
    const id = getCurrentId();
    if (id) {
      liked.items[id] = !liked.items[id];
      localStorage.setItem("sw_liked_2", JSON.stringify(liked.items));
      updateLikeState(liked.items[id]);
      if (liked.items[id]) {
        runLikedParticles(ev);
        onLiked(id);
      }
    }
  }

  function updateLikeState(isLiked: boolean) {
    likeButton.innerHTML = isLiked ? heartIconFilled() : heartIconOutlined();
    // if (isLiked) {
    //   runLikedParticles()
    // }
  }

  function updateCurrentLikeState() {
    const isLiked = getCurrentLikeState();
    updateLikeState(isLiked || false);
  }

  function drawLikedParticles() {
    for (const particle of liked.particles) {
      const p = 0.5 * particle.a * Math.pow(particle.t, 2); //(1/2)at^2
      particle.style.transform = `translate3d(${p * particle.direction[0]}px, ${
        p * particle.direction[1]
      }px, 0)`;
      // particle.style.opacity = String((Number(particle.style.opacity) || 1) - 0.01)
      particle.t++;

      if (particle.t >= 100) {
        liked.particles = liked.particles.filter((v) => v !== particle);
        particle.remove();
      }
    }
    window.requestAnimationFrame(drawLikedParticles);
  }

  drawLikedParticles();

  function runLikedParticles(ev: MouseEvent) {
    const x = ev.clientX;
    const y = ev.clientY;
    for (let i = 0; i < 100; i++) {
      liked.particles.push(runLikedParticle({ x, y }));
    }
  }

  function runLikedParticle({ x, y }: { x: number; y: number }) {
    const element = document.createElement(
      "span"
    ) as (typeof liked)["particles"][0];
    element.classList.add("sw-particle");
    element.style.left = `${x}px`;
    element.style.top = `${y}px`;

    element.t = 0;
    element.a = Math.random();
    element.direction = [0.5 - Math.random(), 0.5 - Math.random()];
    if (likeButton.parentElement) {
      document.body.appendChild(element);
    }

    return element;
  }

  likeButton.addEventListener('click', toggleLikeState)

  return {
    toggleLikeState,
    updateCurrentLikeState
  }
}
